import React, { useState } from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from '../form/View'
import Header from '../form/Header'
import Footer from '../form/Footer'
import DetailsScreen from './DetailsScreen'

const useStyles = createUseStyles(theme => ({
  root: {
    flexDirection: 'column',
    flex: 1,
    flexGrow: 1,
    minHeight: 0,
    overflowX: 'hidden'
  },
  content: {
    flex: 1,
    flexGrow: 1,
    overflowY: 'auto',
    margin: '0 36px',
    flexDirection: 'column',
  },
  loader: {
    justifyContent: 'center'
  },
  link: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '24px',//'14px',
    textDecorationLine: 'underline', 
    color: theme.colors.secondary,
    margin: '32px 0',

    '@media(max-height: 976px)': {
      fontSize: '18px',
    },
  },
  documentContent: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '24px',
    '@media(max-height: 976px)': {
      fontSize: '18px',
    },
  },
  space: {
    height: '16px'
  }
}))

function TermsScreen (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })
  const [ details, setDetails ] = useState(false)

  if (details) {
    return (
      <DetailsScreen 
        title={props.title}
        index={props.index} 
        numOfSteps={props.numOfSteps}
        publicDocumentId={props.publicDocumentId}
        back={() => setDetails(false)}
      />
    )
  }

  const parts = props.content.split('\n')
  return (
    <View className={styles.root}>
      <Header 
        title={props.title}
        index={props.index} 
        numOfSteps={props.numOfSteps} 
        showMarkers={true}
      />

      <View className={styles.content}>
        { parts.map((part, index) => (
          <p key={index} className={styles.documentContent}>{part}</p>
        ))}

        <View className={styles.link} onClick={() => setDetails(true)}>
          { props.link }
        </View>
      </View>
      <View className={styles.space}></View>
      <Footer 
        onBack={() => props.back()}
        onNext={() => props.next({ publicDocumentId: props.publicDocumentId })}
      />
    </View>
  )
}

export default TermsScreen